import React from 'react';
import logo from '../../Images/dlogo/deshilogo.png'
import banner from '../../Images/construction-site.png'

const UnderConstruction = () => {
    return (
        <div>

            <address style={{textAlign:'right',padding:'1%',fontSize:'25px',fontWeight:'700'}}>Say Hello ! deshiagrofoods@gmail.com</address>

            <img src={logo} alt="" style={{ height: '100px', width: '300px',marginLeft:'5%' }} />
            <div style={{ display: 'grid', gridTemplateColumns: '50% 50%' }}>
                <div style={{width:'100%',textAlign:'center',}}>
                    <h1 style={{fontSize:'70px',marginTop:'2%'}}>We are </h1>
                    <h2 style={{fontSize:'35px'}}>Coming Soon...</h2>
                    <p style={{ fontWeight: '700', fontSize: '25px', marginTop: '2%', textTransform: 'capitalize' }}>we are working hard to finish the development of this site</p>
                    <p style={{marginTop:'5%',fontSize:'20px',fontWeight:'600'}}>Develope by- Hasibul IT solution</p>
                </div>
                <div>
                    <img src={banner} alt="" style={{ height: '400px', width: '700px' }} />
                </div>
            </div>

        </div>
    );
};

export default UnderConstruction;